import { environment } from '../../../../../environments/environment';
import { BehaviorSubject, fromEvent, Subject } from 'rxjs';

import { Injectable, NgZone } from '@angular/core';

/**
 * @description
 * @class
 */
@Injectable()
export class GlobalPropertiesService {
  public windowResize$: BehaviorSubject<{ windowHeight: number, windowWidth: number }> = new BehaviorSubject(null);

  public filterByPidd$: Subject<string> = new Subject();



  private defaultCounts = {
      contractsCount: 0,
      pressReleasesCount: 0,
      acquisitionsCount: 0,
      certificationsCount: 0,
      facilitiesCount: 0,
      marketingStoriesCount: 0,
      processesCount: 0,
      technologiesCount: 0,
      patentsCount: 0,
      trademarksCount: 0,
      partnershipsCount: 0,
      businessUnitsCount: 0,
      tweetsCount: 0,
      personnelsCount: 0,
      attachmentsCount: 0,
      opportunityCompetitorsCount: 0
  };

  public dashboard = {
    name: 'counts',
    counts: {
      contractsCount: 0,
      pressReleasesCount: 0,
      acquisitionsCount: 0,
      certificationsCount: 0,
      facilitiesCount: 0,
      marketingStoriesCount: 0,
      processesCount: 0,
      technologiesCount: 0,
      patentsCount: 0,
      trademarksCount: 0,
      partnershipsCount: 0,
      businessUnitsCount: 0,
      tweetsCount: 0,
      personnelsCount: 0,
      attachmentsCount: 0,
      opportunityCompetitorsCount: 0
  }
  };

  public appGlobal = {
    name: 'FSPortal', // name of your project
    author: 'Fed Savvy Strategies', // author's name or company name
    description: 'Empowering your success', // brief description
    activationPhone: '301.760.8977', // activation number shown on system when deactivated
    version: environment.VERSION, // current version
    year: ((new Date()).getFullYear()), // automatic current year (for copyright information)
    isMobile: this.isMobile(),
    impersonationUser: null,
    isImpersonatingUser: false,
    windowHeight: 0,
    windowWidth: 0,
    isLargeDevice: false,
    isSmallDevice: false,
    isMobileDevice: false,
    currentPageTitle: '',
    currentPageSubTitle: '',
    isDesignerMode: false,
    oneTimeSystemKey: '',
    currentSystemZip: '',
    assetBaseURL: '', // some systems like early android webviews, need the full path for assets to load. Set here
    localCachePath: '',
    defaultLayout: {
      isNavbarFixed: true, // true if you want to initialize the template with fixed header
      isLeftSidebarFixed: true, // true if you want to initialize the template with fixed sidebar
      isLeftSidebarClosed: false, // true if you want to initialize the template with closed sidebar
      isLeftSidebarMobileClosed: true, // slide out in mobile mode
      isRightSidebarClosed: true, // true if you want to initialize the template with closed sidebar
      isFooterFixed: true, // true if you want to initialize the template with fixed footer
      isBoxedPage: false, // true if you want to initialize the template with boxed layout
      layoutName: 'lyt-2',
      theme: 'lyt2-theme-1', // indicate the theme chosen for your project
      logo: 'assets/images/fslogo_small.png', // relative path of the project logo
      logoCollapsed: 'assets/images/favicon.png' // relative path of the collapsed logo
    },
    layout: {
      isNavbarFixed: true, // true if you want to initialize the template with fixed header
      isLeftSidebarFixed: true, // true if you want to initialize the template with fixed sidebar
      isLeftSidebarClosed: false, // true if you want to initialize the template with closed sidebar
      isLeftSidebarMobileClosed: true, // slide out in mobile mode
      isRightSidebarClosed: true, // true if you want to initialize the template with closed sidebar
      isFooterFixed: true, // true if you want to initialize the template with fixed footer
      isBoxedPage: false, // true if you want to initialize the template with boxed layout
      layoutName: 'lyt-2',
      theme: 'lyt2-theme-1', // indicate the theme chosen for your project
      logo: 'assets/images/logo.png', // relative path of the project logo
      logoCollapsed: 'assets/images/fs-logo-white-small.png' // relative path of the collapsed logo
    }
  };




  constructor(
    public ngZone: NgZone,

  ) {
    this.appGlobal.layout = JSON.parse(JSON.stringify(this.appGlobal.defaultLayout));
    this.UpdateSizeProps(); // get initial size
    this.StartWatchingResize();
  }

  resetCounts() {
    this.dashboard.counts = JSON.parse(JSON.stringify(this.defaultCounts)); // clone
  }

  isMobile() {
    // true if the browser is a mobile device
    let check = false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      check = true;
    }
    return check;
  }

  StartWatchingResize() {
    // debounce resize, wait for resize to finish before doing stuff
    const resizeObservable = fromEvent(window, 'resize');
    const resizeRateLimited = resizeObservable;

    // resizeObservable.(() => Observable.interval(15));

    resizeRateLimited.subscribe((event) => {
      // wait 50ms before sending event to let things settle
      this.UpdateSizeProps();
    });
  }


  UpdateSizeProps() {
    this.appGlobal.windowHeight = this.viewport().height;
    this.appGlobal.windowWidth = this.viewport().width;

    if (this.appGlobal.windowWidth >= 992) {
      this.appGlobal.isLargeDevice = true;
    } else {
      this.appGlobal.isLargeDevice = false;
    }
    if (this.appGlobal.windowWidth < 992) {
      this.appGlobal.isSmallDevice = true;
    } else {
      this.appGlobal.isSmallDevice = false;
    }
    if (this.appGlobal.windowWidth < 768) {
      this.appGlobal.isMobileDevice = true;
    } else {
      this.appGlobal.isMobileDevice = false;
    }

    // publish changes to subscribers
    this.windowResize$.next({ windowHeight: this.appGlobal.windowHeight, windowWidth: this.appGlobal.windowWidth });

  }

  // Function that finds the exact height and width of the main viewport in a cross-browser way
  viewport() {
    let e: any = window;
    let a = 'inner';
    if (!('innerWidth' in window)) {
      a = 'client';
      e = document.documentElement || document.body;
    }
    return {
      width: e[a + 'Width'],
      height: e[a + 'Height']
    };
  }
}
